<template>
  <div class="ag-device-value-editor ag-device-value-editor_error" @keydown.enter="onEnter">
    <input type="text"
           @keypress="$validateInput($event, 'udouble')"
           v-model="inputModel"
           ref="input"
           class="ag-device-value-editor__input"
           :class="{'ag-device-value-editor__input_error': showError}"
    />
    <div class="ag-device-value-editor__button" title="Поданное показание">
      <div @click.stop="toggleCalculated()" class="ag-device-value-editor__button-calculated"
           :class="{'ag-device-value-editor__button-calculated_active': needSave}">
        <app-icon name="ChevronDown" size="100%"/>
      </div>
    </div>
    <div @click.stop="onBeforeSave" class="ag-device-value-editor__button ag-device-value-editor__button_save">
      <app-icon name="SaveIcon" size="18px" class="ag-device-value-editor__button-icon"/>
    </div>

    <div class="ag-device-value-editor__error" :style="errorStyle" v-if="showError">
      {{errorMessageText}}
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';

  const ERROR_MESSAGES = {
    less: "Вы пытаетесь сохранить показание меньше предыдущего. Вы уверены что хотите сохранить введенное показание?",
    coldWaterMore: "Вы пытаетесь сохранить слишком большой расход (больше 30 кубов). Вы уверены что хотите сохранить введенное показание?",
    hotWaterMore: "Вы пытаетесь сохранить слишком большой расход (больше 20 кубов). Вы уверены что хотите сохранить введенное показание?"
  };

  export default Vue.extend({
    name: "DeviceValueEditor",
    data() {
      return {
        value: null,
        valueBody: null,
        is_standard: false,
        calculated: false,
        needSave: false,
        prevValue: null,
        showError: false,
        errorMessageText: "",
        deviceType: null,
        errorStyle: {
          width: 0,
          left: 0,
          top: 0
        }
      }
    },
    computed: {
      inputModel: {
        get() {
          return this.value;
        },
        set(v) {
          this.showError = false;
          let value = v.replace(/,/g, '.');
          //remove all dots except first
          value = value.replace(/^([^.]*\.)(.*)$/, function (a, b, c) {
            return b + c.replace(/\./g, '');
          });
          if (!value.length) {
            value = null;
          }
          this.$refs.input.value = value;
          this.value = value;
        }
      }
    },
    methods: {
      afterGuiAttached() {
        this.value = JSON.parse(JSON.stringify(this.params.value));
        this.prevValue = JSON.parse(JSON.stringify(this.params.prevValue));
        this.calculated = [true, 'true'].includes(JSON.parse(JSON.stringify(this.params.calculated)));
        this.is_standard = [true, 'true'].includes(JSON.parse(JSON.stringify(this.params.is_standard)));
        this.needSave = !this.calculated;
        this.valueBody = null;
        this.deviceType = this.params.deviceType;

        this.$nextTick(() => {
          let height = this.$el.parentNode.parentNode.style.height;
          this.errorStyle.left = this.$el.parentNode.style.left;
          this.errorStyle.width = this.$el.parentNode.style.width;
          this.errorStyle.top = height;
          this.showError = false;
        });
        this.$refs.input.focus();
      },
      isPopup() {
        return false;
      },
      getValue() {
        return this.valueBody;
      },
      checkErrors(value) {
        let hasError = false;

        if (value < Number(this.prevValue)) {
          // this.showError = true;
          // this.errorMessageText = ERROR_MESSAGES.less;
          hasError = ERROR_MESSAGES.less;
        } else if ([0, 1].includes(this.deviceType)) {
          if (this.deviceType === 0 && value - 30 > Number(this.prevValue)) {
            // this.showError = true;
            // this.errorMessageText = ERROR_MESSAGES.coldWaterMore;
            hasError = ERROR_MESSAGES.coldWaterMore;
          } else if (this.deviceType === 1 && value - 20 > Number(this.prevValue)) {
            // this.showError = true;
            // this.errorMessageText = ERROR_MESSAGES.hotWaterMore;
            hasError = ERROR_MESSAGES.hotWaterMore;
          }
        }

        return hasError;
      },
      onBeforeSave() {
        let value = this.value;
        if (value !== null) {
          if (!isNaN(Number(value))) {
            value = Number(value);
            let errorMessage = this.checkErrors(value);
            if (errorMessage) {
              this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Подтверждение',
                text: errorMessage,
                acceptText: 'Сохранить',
                cancelText: 'Отменить',
                accept: this.save,
                parameters: value
              });
              return;
            } else {
              this.save(value);
              return;
            }
          } else {
            this.save(null);
            return;
          }
        }

        this.save(null);
      },
      save(value) {
        this.valueBody = {
          value: value,
          save: this.needSave
        };
        this.params.stopEditing();
      },
      onEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        this.onBeforeSave();
      },
      toggleCalculated(type) {
        this.needSave = !this.needSave;
        this.$refs.input.focus();
      }
    }
  })
</script>

<style lang="scss">
  .ag-device-value-editor {
    height: 100%;
    display: flex;
    position: relative;

    &__error {
      position: fixed;
      z-index: 9999999;
      display: inline-block;
      color: rgba(var(--app-danger), 1);
      transition: all .25s ease;
      border: 1px solid #eee;
      background: #fff;
      box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
      font-weight: 600;
      text-transform: uppercase;
      padding: 4px;
      line-height: 1.2;
      font-size: .85rem;
      border-radius: 2px;
    }

    &__input {
      border: none;
      width: 100%;
      height: 100%;
      padding: 5px 10px !important;

      &_error {
        color: rgba(var(--app-danger), 1);
      }

      &:focus {
        padding: 5px 10px !important;
        border-bottom: none !important;
      }
    }

    &__button {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1px;

      &_save {
        padding: 0 5px;
      }

      &-icon {
        &:hover {
          cursor: pointer;
          color: rgba(var(--app-success), 1);
        }
      }

      &-calculated {
        border: 1px solid;
        border-radius: 50%;
        height: 18px;
        width: 18px;
        font-size: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        cursor: pointer;
        padding: 4px;

        &_active,
        &:hover {
          background: rgba(var(--app-success), 1);
          border-color: rgba(var(--app-success), 1);
          color: #fff;
        }
      }
    }
  }
</style>
